import api from "../../../../services/api";

const requestUsers = (setFunction = null, varifieFunction = null) => {
  const startTime = Date.now();
  api
    .get("/operator/users")
    .then(response => {
      const endTime = Date.now();
      const rtt = endTime - startTime;
      const receivedAt = endTime;

      const usersWithMeta = response.data.users.map(u => ({
        ...u,
        rtt,
        receivedAt
      }));

      if (setFunction) setFunction(usersWithMeta);
      if (varifieFunction) varifieFunction(true);

      return usersWithMeta;
    })
    .catch(error => { });
};


const getTests = async () => {
  const res = await api.get("/operator/test-names");
  return res.data.tests;
};


const QUESTIONNAIRE_NAMES = {
  "kodkod": "kodkod",
  "ahamnon": "ahamnon",
  "bogrim": "bogrim",
  "mapel": "mapel",
  "קודקוד": "kodkod",
  "אחמנון": "ahamnon",
  "בוגרים": "bogrim",
  "מייפל": "mapel"
};

const fetchQuestionnaireStructure = async (questionnaireName) => {
  const res = await api.get("/operator/questionnaire-structure", {
    params: { questionnaireName: QUESTIONNAIRE_NAMES[questionnaireName] }
  });
  return res.data;
};


const fetchUserAnsweredQuestions = async (userID) => {
  const res = await api.get("/operator/user-detailed-progress", {
    params: { userID }
  });
  return res.data;
};


export { requestUsers, getTests, fetchQuestionnaireStructure, fetchUserAnsweredQuestions };
